import { render, staticRenderFns } from "./InvoicesComponent.vue?vue&type=template&id=f4136492&scoped=true&lang=html&"
import script from "./InvoicesComponent.vue?vue&type=script&lang=js&"
export * from "./InvoicesComponent.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesComponent.vue?vue&type=style&index=0&id=f4136492&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4136492",
  null
  
)

export default component.exports